import { ADD_CHAINSELECTOR_LIST, ADD_CHAINSELECTOR_LIST_ERROR, ADD_CHAINSELECTOR_LIST_SUCCESS, CHAINSELECTOR_LIST, CHAINSELECTOR_LIST_DETAILS, CHAINSELECTOR_LIST_DETAILS_ERROR, CHAINSELECTOR_LIST_DETAILS_SUCCESS, CHAINSELECTOR_LIST_ERROR, CHAINSELECTOR_LIST_SUCCESS, CHAINSELECTOR_LIST_UPDATE, CHAINSELECTOR_LIST_UPDATE_ERROR, CHAINSELECTOR_LIST_UPDATE_SUCCESS, DELETE_CHAINSELECTOR_LIST, DELETE_CHAINSELECTOR_LIST_ERROR, DELETE_CHAINSELECTOR_LIST_SUCCESS } from './constants';




export default function chainselectorreducer(state, action) {


	let chainselectordata = [];
	
	switch (action.type) {
	case CHAINSELECTOR_LIST:
		return {...state, loading: true, error : false};
	case CHAINSELECTOR_LIST_SUCCESS: 
		
		
		if (action.payload && action?.payload && action.payload?.data?.length > 0) {
			action.payload?.data.map( (item) => {
				let data = {};                        
				data.id = item.id ? item.id : null;
				data.name = item.name;
				data.channelinfoId = item.channelinfoId;
				data.pidsinfoId = item.pidsinfoId;
				data.status = item.status;
				data.channelinfoname = item?.channelinfo && item.channelinfo?.name; 
				data.pidsinfoname = item?.pidsinfo && item.pidsinfo?.name; 
				return chainselectordata.push(data);
			});       
			return { ...state, chainselectordata:chainselectordata ,loading: false, error: false };
		} else {
			if (action.payload && action.payload?.data && action.payload?.data?.length === 0) {
				return { ...state, chainselectordata : [] , loading: false, error: false };
			} else {
				return { ...state , loading: false, error: true };
			}
		}
	case CHAINSELECTOR_LIST_ERROR : 
		return { ...state, loading : false, error : true };

	case ADD_CHAINSELECTOR_LIST:
		return {...state, loading : true, error : false };
	case ADD_CHAINSELECTOR_LIST_SUCCESS:
		return {...state, false : true, error : false , };

	case ADD_CHAINSELECTOR_LIST_ERROR:
		return {...state, loading : false, error : true };

	case CHAINSELECTOR_LIST_DETAILS:
		return { ...state, pending: true };
			
	case CHAINSELECTOR_LIST_DETAILS_SUCCESS:
	
		return { ...state, pending: false, details:action.payload, error: false };
	case CHAINSELECTOR_LIST_DETAILS_ERROR:
		return { ...state, pending: false, error: true };

	case CHAINSELECTOR_LIST_UPDATE:
		return { ...state, pending: false };
	case CHAINSELECTOR_LIST_UPDATE_SUCCESS:
		return { ...state, pending: false, error: false };
	case CHAINSELECTOR_LIST_UPDATE_ERROR:
		return { ...state, pending: false, error: true }; 
	case DELETE_CHAINSELECTOR_LIST:
		return { ...state, pending: false };
		
	case DELETE_CHAINSELECTOR_LIST_SUCCESS:
		return { ...state, pending: false, error: false };
		
	case DELETE_CHAINSELECTOR_LIST_ERROR:
		return { ...state, pending: false, error: true };
	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}